//      

                                         
import {getConfig} from "../reducers/configReducer";
import {hasFractionDigits, hideFractionDigitsForEdge} from "./priceUtil";

const getFormat = (priceValue        , fractionDigits         = "", originPrice) => {
	switch (fractionDigits.toLowerCase()) {
		case "2":
			return {
				...{
					maximumFractionDigits: 2,
					minimumFractionDigits: 2,
				}
			};
		default:
			return (hasFractionDigits(priceValue))
				? {
					...{
						maximumFractionDigits: 2,
						minimumFractionDigits: 2,
					},
				}
				: {
					...{
						maximumFractionDigits: 0,
						minimumFractionDigits: 0,
					},
					...hideFractionDigitsForEdge(originPrice)
				};
	}
};

const currencyConverter = (price       , catalogPrice        = price, lang         = getConfig().language, fractionDigits         = getConfig().fractionDigits) => {
	return new Intl.NumberFormat(lang, {
		...getFormat((catalogPrice || {}).value, fractionDigits, (price || {}).value),
		...{style: "currency", currency: price.currency}
	}).format(price.value);
};

export default currencyConverter;
